import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import AppShell, { EmptyState } from "@/components/app/AppShell";
import api from "@/lib/api";

export default function Notifications() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const readOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <AppShell title="Notifications" back={{ to: "/app", label: "Dashboard" }}>
      {items && items.some((n) => !n.read) && (
        <button onClick={readAll} className="mb-4 inline-flex items-center gap-1.5 text-sm font-semibold text-tblue hover:underline" data-testid="read-all-btn">
          <CheckCheck size={15} /> Mark all as read
        </button>
      )}
      {items === null ? (
        <div className="h-24 animate-pulse rounded-md bg-white" />
      ) : items.length === 0 ? (
        <EmptyState icon={Bell} title="No notifications" body="Updates about your cases will appear here." />
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <Link key={n.id} to={n.action_url || "/app"} onClick={() => readOne(n.id)} data-testid={`notif-${n.id}`}
              className={`block rounded-md border p-4 transition-colors ${n.read ? "border-hborder bg-white" : "border-tblue/30 bg-ltblue/40"}`}>
              <div className="flex items-center justify-between">
                <p className="font-medium text-heading">{n.title}</p>
                {!n.read && <span className="h-2 w-2 rounded bg-coral" aria-label="unread" />}
              </div>
              <p className="mt-1 text-sm text-muted">{n.body}</p>
              <p className="mt-1 text-xs text-muted/70">{new Date(n.created_at).toLocaleString()}</p>
            </Link>
          ))}
        </div>
      )}
    </AppShell>
  );
}
